import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useSite } from "@/context/SiteContext";
import { PageHero, Img, DemoBadge } from "@/components/common";
import useTitle from "@/lib/useTitle";
import { http, fileUrl } from "@/lib/api";

export default function Galeria() {
  useTitle("Galeria");
  const { data } = useSite();
  const [ed, setEd] = useState(data.edition.slug);
  const [galleries, setGalleries] = useState(data.galleries);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    if (ed === data.edition.slug) { setGalleries(data.galleries); return; }
    http.get("/public/bundle", { params: { edition: ed } }).then((r) => setGalleries(r.data.galleries)).catch(() => setGalleries([]));
  }, [ed, data]);

  return (
    <>
      <PageHero eyebrow="Galeria e memória" title="Galeria" tone="#be185d" image="/img/art.jpg">Fotografias e vídeos organizados por edição. <Link to="/memoria" className="underline font-semibold">Conheça a Memória da Feira</Link>.</PageHero>
      <div className="container-x py-10">
        <div className="flex gap-2 flex-wrap" role="tablist" aria-label="Edição">
          {data.editions.map((e) => {
            const cur = e.slug === data.edition.slug;
            return <button key={e.id} role="tab" aria-selected={ed === e.slug} disabled={!cur} onClick={() => setEd(e.slug)} data-testid={`gallery-edition-${e.slug}`} className={`h-12 px-5 rounded-full font-semibold border inline-flex items-center gap-2 ${ed === e.slug ? "bg-[var(--ink)] text-white" : "bg-white"} ${cur ? "" : "opacity-70 cursor-not-allowed"}`}>{e.year}{!cur && <span className="text-[11px] font-semibold text-amber-900">Em desenvolvimento</span>}</button>;
          })}
        </div>
        {galleries.length === 0 && <p className="py-16 text-slate-600" data-testid="gallery-empty">As fotografias desta edição serão publicadas após a Feira.</p>}
        {galleries.map((g) => (
          <section key={g.id} className="mt-10" aria-label={g.title}>
            <h2 className="font-display text-3xl font-extrabold">{g.title}</h2>
            {g.description && <p className="text-slate-700 mt-2">{g.description}</p>}
            <DemoBadge show={g.demo} className="mt-2" />
            <ul className="mt-6 columns-2 md:columns-3 lg:columns-4 gap-3 [&>li]:mb-3">
              {(g.items || []).map((it, i) => (
                <li key={i} className="break-inside-avoid">
                  <button onClick={() => setOpen(it)} className="block w-full rounded-2xl overflow-hidden focus-visible:ring-4" aria-label={`Ampliar: ${it.alt || it.caption || "imagem"}`} data-testid={`gallery-item-${i}`}>
                    {it.type === "video" ? <video src={fileUrl(it.url)} className="w-full" muted /> : <Img src={it.url} alt={it.alt} className={`w-full object-cover ${i % 3 === 0 ? "aspect-[3/4]" : "aspect-square"}`} />}
                  </button>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={() => setOpen(null)}>
        <DialogContent className="max-w-5xl p-2 bg-black border-0" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{open?.caption || "Imagem"}</DialogTitle>
          {open && (open.type === "video" ? <video src={fileUrl(open.url)} controls autoPlay className="w-full max-h-[80vh]" /> : <img src={fileUrl(open.url)} alt={open.alt} className="w-full max-h-[80vh] object-contain" />)}
          {open?.caption && <p className="text-white/80 text-sm px-2 pb-1">{open.caption}</p>}
        </DialogContent>
      </Dialog>
    </>
  );
}
